
import { Component, Vue, } from 'vue-property-decorator';
import { NavigationGuardNext, } from 'vue-router';
import { Store, } from '~/apps/account/store';
import RegistrationProgressSteps from '~/components/register/register-progress-steps.vue';

@Component({
	components: {
		RegistrationProgressSteps,
	},
	metaInfo: {
		title: 'Digital billing for Your Account - Southern Water',
		meta: [
			{
				name: 'description',
				content: 'Southern Water Your Account, an easy, quick and secure way to make payments, tell us you\'re moving, view bills, track your water usage and manage your details. Register for Your Account today.',
			},
		],
	},
})
export default class EbillingRegisterMaster extends Vue {
	get currentStep() {
		return Store.state.register.currentStep;
	}

	beforeRouteLeave(_to: unknown, _from: unknown, next: NavigationGuardNext<Vue>) {
		Store.commit.register.reset();
		next();
	}
}
